"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _clientsContacts = require("@/api/clients-contacts");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _common = require("@/api/common");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.redirectToList = false;
    this.isDuplicateMobile = false;
    this.mobileAlert = null;
    this.allowContactTransfer = false;
    this.currentMobileNumber = null;
    this.isSameClient = false;
    this.duplicateContactId = null;
    this.gstFileList = [];
    this.gstFile = null;
    this.previewVisible = false;
    this.previewUrl = '';
    this.communicationType = [{
      key: 'Call',
      value: 'Call'
    }, {
      key: 'Email',
      value: 'Email'
    }, {
      key: 'Whatsapp',
      value: 'Whatsapp'
    }, {
      key: 'Physical Meet',
      value: 'Physical Meet'
    }, {
      key: 'Other',
      value: 'Other'
    }];
    this.salutationType = [{
      key: 'Mr',
      value: 'Mr'
    }, {
      key: 'Mrs',
      value: 'Mrs'
    }, {
      key: 'Miss',
      value: 'Miss'
    }, {
      key: 'Dr',
      value: 'Dr'
    }];
    this.userOptions = [{
      label: 'Pending',
      key: 'Pending'
    }, {
      label: 'Approved',
      key: 'Approved'
    }, {
      label: 'Rejected',
      key: 'Rejected'
    }];
    this.formData = Object.assign({}, _clientsContacts.defaultClientsContactData);
    this.loading = false;
    this.rules = {
      firstName: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      lastName: [{
        required: false
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      mobileNumber: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        pattern: /^\d+$/,
        message: 'Please enter numbers only',
        trigger: 'blur'
      }, {
        min: 10,
        max: 10,
        message: 'Length should be 10',
        trigger: 'blur'
      }],
      emailAddress: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        type: 'email',
        message: 'Please enter correct email address',
        trigger: ['blur']
      }],
      address: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }],
      panNumber: [{
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
        message: 'Invalid PAN format (e.g. ABCDE1234F)',
        trigger: 'blur'
      }]
    };
  }
  handlePreview(file) {
    this.previewUrl = file.url;
    this.previewVisible = true;
  }
  handleGSTFileChange(file) {
    this.gstFile = file.raw;
    this.gstFileList = [file];
  }
  handleGSTRemove() {
    this.gstFile = null;
    this.gstFileList = [];
    this.formData.gstAttachment = null;
  }
  get lang() {
    return _app.AppModule.language;
  }
  handleGSTChange(value) {
    if (value && value.length >= 12) {
      this.formData.panNumber = value.substring(2, 12).toUpperCase();
    } else {
      this.formData.panNumber = '';
    }
  }
  created() {
    console.log('ROUTE QUERY:', this.$route.query);
    this.currentMobileNumber = null;
    const query = this.$route.query;
    // ✅ EDIT MODE
    if (this.isEdit) {
      if (this.$route.params && this.$route.params.id) {
        this.contactId = +this.$route.params.id;
        this.redirectToList = true;
      }
      this.fetchData(this.contactId);
    }
    // ✅ CREATE MODE
    else {
      // 🔥 IMPORTANT: mutate, don't replace
      Object.assign(this.formData, _clientsContacts.defaultClientsContactData);
      // ✅ Prefill Email
      if (query.email) {
        this.formData.emailAddress = query.email;
        const namePart = query.email.split('@')[0];
        const parts = namePart.split(/[._]/);
        this.formData.firstName = parts[0] || '';
        this.formData.lastName = parts[1] || '';
      }
      // ✅ Set clientId
      if (query.clientId) {
        this.clientId = Number(query.clientId);
      }
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _clientsContacts.getClientsContactById)(id);
      if (data) {
        this.formData = data;
        // set client ID
        this.clientId = data.clientId;
        if (data.gstAttachment) {
          this.gstFileList = [{
            name: 'GST File',
            url: data.gstAttachment
          }];
        }
        // set mobile number
        this.currentMobileNumber = data.mobileNumber;
      }
      // Just for test
      const title = 'Edit';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (error) {
      this.$message.error(error.toString());
    }
  }
  async validateMobileNumber() {
    try {
      this.isSameClient = false;
      this.isDuplicateMobile = false;
      this.allowContactTransfer = false;
      this.duplicateContactId = null;
      if (this.formData.mobileNumber && this.formData.mobileNumber !== this.currentMobileNumber) {
        // check if already exists
        const res = await (0, _clientsContacts.validateMobile)({
          mobileNumber: this.formData.mobileNumber
        });
        if (res && res.data) {
          this.duplicateContactId = res.data.id;
          this.isDuplicateMobile = true;
          this.mobileAlert = res.message;
          // check if same client
          if (this.clientId && this.clientId === res.data.clientId) {
            this.isSameClient = true;
            this.mobileAlert = 'This number already exists in your client contacts.';
          }
        } else {
          this.isSameClient = true;
        }
      }
    } catch (error) {
      this.$message.error(error.toString());
    }
  }
  handleMobileInput(value) {
    const digitsOnly = (value || '').replace(/\D+/g, '').slice(0, 10);
    if (this.formData.mobileNumber !== digitsOnly) {
      this.formData.mobileNumber = digitsOnly;
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title} - ${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  allowSubmit() {
    let disableSubmit = false;
    if (this.isDuplicateMobile && !this.allowContactTransfer) {
      disableSubmit = true;
    }
    return disableSubmit;
  }
  submitForm() {
    if (!this.clientId) {
      this.$alert('Please add client first', 'Warning', {
        type: 'warning'
      });
      return false;
    }
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.clientId = this.clientId;
      this.formData.client = {
        id: this.clientId
      };
      // send null for blank optional unique fields to avoid DB unique constraint on empty string
      if (!this.formData.panNumber) this.formData.panNumber = null;
      if (!this.formData.gstNumber) this.formData.gstNumber = null;
      let savedContact = null;
      if (this.gstFile) {
        const formData = new FormData();
        formData.append('file', this.gstFile);
        const fileUrl = await (0, _common.uploadFile)(formData);
        this.formData.gstAttachment = fileUrl;
      }
      if (this.isEdit) {
        savedContact = await (0, _clientsContacts.updateClientsContact)(this.formData.id, this.formData);
      } else {
        savedContact = await (0, _clientsContacts.createClientsContact)(this.formData);
      }
      // 🔥 👉 ADD REDIRECT HERE
      if (this.$route.query.from === 'addToLead') {
        this.$router.push({
          path: '/leads/add',
          query: {
            clientId: String(this.clientId),
            contactId: String(savedContact.id),
            email: this.formData.emailAddress,
            from: 'addToLead',
            step: 'lead'
          }
        });
        return; // ❗ VERY IMPORTANT (stop further execution)
      }
      // check if duplicate contact ID exists, disable it after transfter
      if (this.allowContactTransfer && this.duplicateContactId) {
        await (0, _clientsContacts.updateClientsContact)(this.duplicateContactId, {
          enabled: false
        });
      }
      this.$notify({
        title: 'Success',
        message: 'Contact saved',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      this.$emit('updated', false);
      this.$emit('saved', {
        showDialog: false,
        data: savedContact
      });
      if (this.redirectToList) {
        _router.default.push('/clients-contacts/list');
      }
    } catch (error) {
      var _error$response;
      this.loading = false;
      const msg = (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.message) || (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.toString()) || '';
      if (msg.includes('panNumber')) {
        this.$message.error('This PAN number is already registered with another contact.');
      } else if (msg.includes('gstNumber')) {
        this.$message.error('This GST number is already registered with another contact.');
      } else if (msg.includes('mobileNumber') || msg.includes('mobile')) {
        this.$message.error('This mobile number is already registered with another contact.');
      } else if (msg.includes('emailAddress') || msg.includes('email')) {
        this.$message.error('This email address is already registered with another contact.');
      } else {
        this.$message.error(msg || 'Failed to save contact. Please try again.');
      }
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 0
})], default_1.prototype, "clientId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 0
})], default_1.prototype, "contactId", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientsContactDetail',
  components: {}
})], default_1);
var _default = exports.default = default_1;